export class ServiceType {
	Id: number;
	Name: string;
	CreatedOn: Date;
	ModifiedOn: Date;
	ModifiedByUserId: number;
	ReviewedOn: Date;
	ReviewedByUserId: number;
	Active: boolean;
}
